import { CompactInlineAlertWidget, InlineAlertType } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/common/react/CommonStyles';
import { ReactConfirmationDialogBodyProps } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { cssClass } from '~src/style';

export function DisableLinkedTaskDialogWarning(props: ReactConfirmationDialogBodyProps): JSX.Element {
  const warning = cssClass('disable-linked-task-dialog', 'warning', {
    paddingBottom: CommonStyles.Sizes.MediumSpace,
  });
  return (
    <div className={warning}>
      <div className={warning}>
        {props.message}
      </div>
      <CompactInlineAlertWidget testId={'disable-linked-task-warning'} type={InlineAlertType.Warning}>
        {Messages.linkedTasksDisableDialogWarning()}
      </CompactInlineAlertWidget>
    </div>
  );
}